export default {
  title: 'Thanks for letting us know!',
  body: 'We respect your decision and we will no longer send {email} any Kintell invitation reminders.',
  subbody: 'If you end up changing your mind, please {getInTouch} :)',
}
